module.exports = __webpack_public_path__ + "images/business-class/feature-boards.ae0af621e02da95fe156.svg";